import React from 'react';

const MobileDevelopment = () => {
  return (
    <div>
      <h1>About Us</h1>
      <p>This is the About page content.</p>
    </div>
  );
};

export default MobileDevelopment;